export * from './abschnitt-entfernt.interface';
